<template>
    <div class="header-container">
        <div class="logo-container" @click="$router.push('/')">
            <Logo color="white" class="logo"></Logo>
            <span>Truth Tree</span>
        </div>
        <div class="logout-container" @click="$emit('click', $event)">
            <Clickable>Logout</Clickable>
        </div>
    </div>
</template>

<script>
    import Clickable from './Clickable.vue';
    import Logo from './Logo.vue';

    export default {
        data() {
            return {};
        },
        components: {
            Clickable,
            Logo
        }
    }
</script>

<style scoped lang="scss">
    .header-container {
        width: 100%;
        height: 50px;

        background-color: $primaryColor;
        box-shadow: $primary-shadow;

        color: white;

        display: flex;
        flex-direction: row;
        align-items: center;

        position: relative;

        .logo-container {
            cursor: pointer;
            margin-left: $space-64;
            font-size: $space-32;
            font-weight: $bold;
            // position: relative;

            .logo {
                position: relative;
                top: $space-4;
                width: $space-32;
                height: $space-32;
                margin-right: $space-8;
            }
        }

        .logout-container {
            position: absolute;
            right: $space-64;
        }
    }
</style>